import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import serialize from 'form-serialize';
import makeRequest from 'utils/makeRequest';
import s from './EmailSharingNonPrime.scss';

function getSerializeData(data) {
  const formData = [];
  const keys = Object.keys(data);
  for (let i = 0; i < keys.length; i += 1) {
    formData.push(`${keys[i]}=${data[keys[i]]}`);
  }

  return formData.join('&');
}
class EmailSharingNonPrime extends React.Component {
  constructor() {
    super();
    this.state = {
      captchaImgSrc: '',
      showCaptchaError: false,
      captchaError: '',
      showEmailSuccessMsg: false,
    };
  }

  componentWillMount() {
    this.setState({
      captchaImgSrc: `https://www.timesofindia.indiatimes.com/getCaptchaImage?type=mail&msid=${
        this.props.msid
      }&rand=${Math.random()}`,
    });
  }

  refreshCaptcha = () => {
    this.setState({
      captchaImgSrc: `https://www.timesofindia.indiatimes.com/getCaptchaImage?type=mail&msid=${
        this.props.msid
      }&rand=${Math.random()}`,
    });
  };

  mailtrim = (mvalue = '') => {
    let temp1 = mvalue;
    const obj1 = /^(\s*)([\W\w]*)(\b\s*$)/;
    if (obj1.test(temp1)) {
      temp1 = temp1.replace(obj1, '$2');
    }
    const obj2 = / {2}/g;
    while (temp1.match(obj2)) {
      temp1 = temp1.replace(obj2, ' ');
    }
    return temp1;
  };

  checkMail = inmail => {
    const zz = inmail;
    const x = zz.replace(/\s+/g, '');
    let y = 0;
    const filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (x.indexOf(',') !== -1) {
      const seperatevalues = x.split(',');
      let xx = 0;
      for (xx = 0; xx < seperatevalues.length; xx += 1) {
        if (filter.test(seperatevalues[xx])) y += 1;
      }
      if (xx === y) return true;
      return false;
    }
    if (filter.test(x)) return true;
    return false;
  };

  sendMail = e => {
    e.preventDefault();
    if (typeof document !== 'undefined') {
      const form = document.querySelector('#mailformId');
      const str = serialize(form, { hash: true });
      const checkToMail = this.checkMail(this.mailtrim(str.toaddress));
      const checkFromMail = this.checkMail(this.mailtrim(str.replyto));
      const checkValidName = !!str.fromname1 && str.fromname1 !== 'Your Name';
      const checkBlankCaptch = !!str.captchaText;
      if (checkToMail && checkFromMail && checkValidName && checkBlankCaptch) {
        const config = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        };
        const url = `https://timesofindia.indiatimes.com/json/postmail.cms`;
        makeRequest.post(url, getSerializeData(str), config).then(data => {
          if (
            Object.prototype.hasOwnProperty.call(data.data.postmail, 'error')
          ) {
            this.setState({
              showCaptchaError: true,
              captchaError:
                data.data.postmail.error && data.data.postmail.error.xmlns
                  ? data.data.postmail.error.xmlns
                  : '',
            });
          } else {
            this.setState({
              showEmailSuccessMsg: true,
            });
          }
        });
      } else if (!checkToMail) {
        alert(
          'Please enter a valid email address in - Receivers Email Address Field',
        );
        document.mailform.toaddress.focus();
      } else if (!checkFromMail) {
        alert('Please enter a valid email address in - Your Email Address');
        document.mailform.replyto.focus();
      } else if (!checkValidName) {
        alert('Please enter Your name');
        document.mailform.fromname1.focus();
      } else if (!checkBlankCaptch) {
        alert('Please enter valid Captcha');
        document.mailform.captchaText.focus();
      }
    }
  };

  emailPopup = () => {
    const { url, title } = this.props;
    if (this.state.showEmailSuccessMsg) {
      return (
        <div className={s.success_msg}>
          <span>{this.props.successMsgTitle}</span>
          {this.props.successMsgText}
        </div>
      );
    }
    return (
      <>
        <div className={s.email_icon} />
        <div className={s.email_right}>
          {typeof this.props.isMailHeadingAvailable === 'string' ? (
            <h3>{this.props.isMailHeadingAvailable}</h3>
          ) : (
            <h3>Mail this article</h3>
          )}
          <form id="mailformId" name="mailform">
            <input
              name="subject"
              type="hidden"
              value={`Timesofindia.com: ${title}`}
            />
            <input
              name="pgtitle"
              type="hidden"
              value={`Timesofindia.com: ${title}`}
            />
            <input name="syn" type="hidden" value="" />
            <input value="Times Of India" name="subject1" type="hidden" />
            <input value="Times Of India" name="mailtitle" type="hidden" />
            <input value="Times Of India" name="title" type="hidden" />
            <input type="hidden" name="configid" value="22806473" />
            <input
              value="timesofindia.indiatimes.com"
              name="servername"
              type="hidden"
            />
            <div className={s.col1}>
              <input
                type="text"
                name="toaddress"
                placeholder="Recipient's mail"
                maxLength="255"
              />
              {this.props.notificationMsg ? (
                <div className={s.noticationmsg}>
                  {this.props.notificationMsg}
                </div>
              ) : null}
            </div>
            <div className={s.col2}>
              <span className={s.inputwrapper}>
                <input
                  type="text"
                  name="fromname1"
                  placeholder="Your Name"
                  maxLength="300"
                />
                <input
                  value="mailerservice@timesofindia.com"
                  className="txtbox"
                  maxLength="300"
                  name="fromname"
                  type="hidden"
                />
              </span>
              <span className={s.inputwrapper}>
                <input
                  type="text"
                  name="replyto"
                  maxLength="300"
                  placeholder="Your Email ID"
                />
                <input
                  value="mailerservice@timesofindia.com"
                  name="fromaddress"
                  type="hidden"
                />
              </span>
            </div>

            <div className={s.col2}>
              <span className={s.inputwrapper}>
                <input
                  type="text"
                  name="captchaText"
                  id="captcha"
                  placeholder="Captcha / Image value"
                  autoComplete="off"
                />
              </span>
              <span className={s.inputwrapper}>
                <img
                  title="Captcha"
                  id="captchaImg"
                  src={this.state.captchaImgSrc}
                  alt="captcha"
                />
                <img
                  src="https://static.toiimg.com/photo/48786760.cms"
                  title="refresh captcha"
                  alt="refresh"
                  onClick={this.refreshCaptcha}
                  className={s.captcha_refresh}
                />
              </span>
            </div>
            {this.state.showCaptchaError ? (
              <div className={s.captchaerror_msg}>
                {this.state.captchaError}
              </div>
            ) : null}
            <input name="ArticleID" type="hidden" value={this.props.msid} />
            <input name="msid" type="hidden" value={this.props.msid} />
            <input name="articlelink" type="hidden" value={url} />
            <input
              type="submit"
              value="Submit"
              onClick={e => this.sendMail(e)}
              className={s.submitbtn}
            />
          </form>
        </div>
      </>
    );
  };

  render() {
    const containerClass = classNames({
      [`${s.email_overlaywrapper}`]: true,
      'prime-article': this.props.isPrime,
    });
    const { closeEmailPopup = () => {} } = this.props;

    return (
      <div className={containerClass}>
        <div className={s.email_overlay}>
          <div className={s.email_close} onClick={closeEmailPopup}>
            X
          </div>
          {this.emailPopup()}
        </div>
      </div>
    );
  }
}

EmailSharingNonPrime.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  msid: PropTypes.string.isRequired,
  successMsgTitle: PropTypes.string.isRequired,
  successMsgText: PropTypes.string.isRequired,
  notificationMsg: PropTypes.string,
  isPrime: PropTypes.bool,
  closeEmailPopup: PropTypes.func,
  isMailHeadingAvailable: PropTypes.string,
};

EmailSharingNonPrime.defaultProps = {
  notificationMsg:
    '(For more than one recipient, type addresses separated by commas)',
  isPrime: false,
  closeEmailPopup: undefined,
  isMailHeadingAvailable: undefined,
};

export default EmailSharingNonPrime;
